import React,{useState,useEffect} from "react";
import GoogleMapReact from 'google-map-react';
import MyMarker from "./MyMarker";
import Polylineonmap from "./Polylineonmap";
import SubMarker from "./SubMarker";
import axios from "axios";
import avtlogo from "../../img/truck.png";
import avtlogo2 from "../../img/Truck2.png";
import { getUserId, getUser, getLoginName,aPIURL} from '../../utils/common';
import Modal from "../Modal";
import ModalHistory from "../Modal";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingSpinner from "../LoadingSpinner";
import { useNavigate } from "react-router-dom";
import UserPoligone from "../MapPoligone"
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { post } from "jquery";
import RouteonMap from "./RouteonMap";
import Playback from "./PlayBack";
import { CopyToClipboard } from 'react-copy-to-clipboard'
import $ from 'jquery'; 
import HistoryonMap from "./HistoryonMap";
import DashboardMap from "./DashboardMap";



function VehiclesMonitor() 
{ 

  var indx=0;
  var tripCoordinates = [];  
  const [datapoints,setdataPoints] =useState([]);
  const [subdatapoints,setsubdataPoints] =useState([]);

  const history = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [vAlert, setVAlert] = useState([]);   
  const [alertTotal, setAlertTotal] = useState(0);
  const[msg_Type,setMsg_Type]=useState([0]);   
  const [VData, setVDatas] = useState([]);   
  const [deviceTotal, setDeviceTotal] = useState(0);
  const API_URL=aPIURL();
  var fday = new Date();
  var fdd = fday.getDate();
  var fmm = fday.getMonth() + 1; //January is 0 so need to add 1 to make it 1!
  var fyyyy = fday.getFullYear();
  if (fdd < 10){fdd = '0' + fdd}
  if (fmm < 10){fmm = '0' + fmm}
  fday = fyyyy + '-' + fmm + '-' + fdd;
  
  const [filterDate, setFilterDate]= useState(fday);  
  const [frFilterDate, setFrFilterDate]= useState(fday); 
  const [toFilterDate, setToFilterDate]= useState(fday); 
  let [parked, setParked] = useState(0);
  let [moving, setMoving] = useState(0);
  let [idle, setIdle] = useState(0);
  let [notUpdated, setNotUpdated] = useState(0);
  const [defaultCenter, setPosts] = useState([]);  
  let [lat, setLatitude] = useState();//28.61394, lng:77.20902
  let [long, setLlongitude] = useState();
  const [historyData, setHistoryData] = useState([]);
  const [showDetails,setShowDetails]= useState(false);
  const [showRoute,setShowRoute]= useState(false);
  const [showRoutePlayback,setShowRoutePlayback]= useState(false);
  const [showAlerts,setShowAlerts]=useState(false);
  const [showPlayBackDetails,setShowPlayBackDetails]=useState(false);
  const [imeiNo,setImeiNo]= useState(0);
 
  let IEMI='0';
  let Svehicleno;
  let countvehicle=1;
  const user_name = getUser();
  const AccountID =getUserId();  
  const login_name = getLoginName();
  let [typeID, setTypeID] = useState(0);
  let SMSType=false;  
 
  const[currentAddrs,setCurrentAddrs]=useState();
  const [items,setItems]= useState([]);
  const [isShowMap, setIShowMap] = useState(false);
  const [isShowTable, setIShowTable] = useState(true);

  const [VHI,setVHI]=useState(imeiNo);
  const [VfromDate,setVfromDate]=useState(today);
  const [VtoDate,setVtoDate]=useState(today);
  const [VTripno,setVTripno]=useState();
  const [route_Info,setRoute_Info] = useState({}); 
  //let [oldComponent,setOldcomponent] = useState(); 
  //let [newComponent,setNewComponent] = useState(); 
  const routeinfo={vehicleno:VHI,Tripno:VTripno,FromDate:filterDate}
  //const store = createStore(taskList);
   //GT-196 

  const [account_ID,setAccount_ID]=useState(0);
  const [device_ID,setDevice_ID]=useState(0);
  const [type_ID,setType_ID]=useState(0);
  const mapData={accountid:account_ID,deviceId:device_ID,typeid:type_ID}
  let myComponent=<DashboardMap objmapdata = { mapData }/>  
  
  const [vehicleNo,setVehicleNo]=useState('0');
  let [sLatlong, setSLatlong] = useState({});//28.61394, lng:77.20902

  //For history on map serach
  const [himei,setHimei]=useState();
  const [hfromdt,setHfromdate]=useState();
  const [htodate,setHtodate]=useState();
  const historyonmapinfo={IMEI:himei,fromDate:hfromdt,toDate:htodate}

    useEffect(() => 
    {
        setIsLoading(true);
        AutoSearch(0);
        Mapdisplay(AccountID,0);
        ViewDashboardCount();       
        showVehicleAlert(1);       
       
    },[]);

    function getMonday(d) 
    {
        d = new Date(d);      
        var day =d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
        return new Date(d.setDate(diff)).toLocaleDateString('en-CA');
    }
 
    //date start
    //mindate start
    let minDate = new Date()
    minDate.setDate(minDate.getDate() - 30)
    var dd1 = minDate.getDate();
    var mm1 = minDate.getMonth() + 1; 
    var yyyy1 = minDate.getFullYear();

    if (dd1 < 10) {dd1 = '0' + dd1}
    if (mm1 < 10) {mm1 = '0' + mm1}
    minDate = yyyy1 + '-' + mm1 + '-' + dd1;
//min date end
//mindate date range start
   let minDatefr = new Date()
   minDatefr.setDate(minDatefr.getDate() - 60)
   var ddfr = minDatefr.getDate();
   var mmfr = minDatefr.getMonth() + 1; 
   var yyyyfr = minDatefr.getFullYear();

   if (ddfr < 10) {ddfr = '0' + ddfr}
   if (mmfr < 10) {mmfr = '0' + mmfr}
   minDatefr = yyyyfr + '-' + mmfr + '-' + ddfr;
//mindate date range end
//max date start
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0 so need to add 1 to make it 1!
    var yyyy = today.getFullYear();

    if (dd < 10) {dd = '0' + dd}
    if (mm < 10) {mm = '0' + mm}
    today = yyyy + '-' + mm + '-' + dd;
     
//max date end
    const GoToPage = (vehicleNumber,Tripno) => 
      {     
        setVHI(vehicleNumber);
        setVTripno(Tripno); 
        setShowDetails(false);
        setShowAlerts(false);
        setShowRoute(true);
        setShowRoutePlayback(false);
        setShowPlayBackDetails(false);
            
        // var config;
       //  window.open('/TermsofUse','newwindow',"_self", config='height=670,width=1400');
      }
      const GoToroutePlaybackPage = (vehicleNumber,Tripno) => 
        {  
                            
          setVHI(vehicleNumber);
          setVTripno(Tripno); 
          setVfromDate(filterDate);
          setShowDetails(false);
          setShowAlerts(false);
          setShowPlayBackDetails(false); 
          setShowRoute(false);
          setShowRoutePlayback(true);
          
                     
        }
      const GoToViewLivePage = () => 
        {
          IEMI=document.getElementById("hdndeviceId").value;
          let urlString="/CViewLive?ID="+IEMI;          
          history(urlString); // Dynamic call pages   
            
        };
 //Short URL 24 hours
 const ShowTodayData=()=>
  {  
    
    setFrFilterDate(today);
    setToFilterDate(today);
    setHfromdate(today);
    setHtodate(today);   
   
  }
  const ShowWeeklyData=()=>
  {
    
     var Startdt=getMonday(new Date());
     setHimei(imeiNo);
     setFrFilterDate(Startdt);
     setToFilterDate(today);
     setHfromdate(Startdt);    
     setHtodate(today); 
     
  }
  const ShowMonthlyData=()=>
  {
     
     var DateFirstdayofMonth = new Date();
     var firstDay = new Date(DateFirstdayofMonth.getFullYear(), DateFirstdayofMonth.getMonth(), 1).toLocaleDateString('en-CA');
     setFrFilterDate(firstDay);
     setToFilterDate(today);
     setHimei(imeiNo);
     setHfromdate(firstDay);
     setHtodate(today);

     
  }
   
   const ShowSearchData=()=>
   {
     if(frFilterDate> toFilterDate)
      {
        toast.error("From date should be less than to date.");
        return;
      }
      else
      {
          setHimei(imeiNo);
          setHfromdate(frFilterDate);
          setHtodate(toFilterDate);
      }
   }
  const ShowMap=()=>
  {  
      setIShowMap(false); 
      setIShowTable(true);     
  }
  const showTable=()=> 
  {  
      setIShowMap(true); 
      setIShowTable(false);      
  }
  

 const  copyToURL = (event) => 
  {
    const WEB_URL=process.env.REACT_APP_WEB;//    wEBURL();    
    IEMI=document.getElementById("hdndeviceId").value;
    
    setImeiNo(IEMI);
    const daurls=API_URL+`Externaltoken/${IEMI}/24`; 
   
    const response =  axios.post(daurls).then(response => 
     {
        
        const copyurls=WEB_URL+`Monitor.html?token=${response.data.data[0].token}`;  

        //await  navigator.clipboard.writeText(copyurls);
        navigator.clipboard.writeText(copyurls)
        .then(() => {
          alert("successfully copied,Please share url for 24 hours");
        })
        .catch(() => {
          alert("something went wrong");
        });
    
      }).catch(function(error) 
     {
       console.log(error.message);
     });  
}
 
// note: the id field is mandatory

const AutoSearch=(TypeID)=>
  {
    setItems([]);
    const daurls=API_URL+`AutoSearchVList/${AccountID}/${TypeID}`; 
   
    const response =  axios.get(daurls).then(response => 
      {       
                   
            setItems(response.data.items);
            
      }).catch(function(error) 
       {
            console.log(error.message);

      });    
   
    
  }
const handleOnSearch = (string, results) => 
{ 
// onSearch will have as the first callback parameter
// the string searched and for the second the results.
console.log(string, results)
}

const handleOnHover = (result) => {
// the item hovered
console.log(result)
}

const handleOnSelect = (items) => {
console.log(items)
VehicleMarker(items.id);
}

const handleOnFocus = () => 
{  
console.log('Focused')
}
const closeModal = () => {
  setShowDetails(false);
  setShowAlerts(false);
  setShowRoute(false);
  setShowRoutePlayback(false);
  setShowPlayBackDetails(false);
}

const formatResult = (items) => {
return (
<>

  <span style={{ display: 'none', textAlign: 'left' }}>{items.id}</span>
  <span style={{ display: 'block', textAlign: 'left' }}>{items.name}</span>
</>
)
}
  const VehicleMarker=(id)=>
  {
        Mapdisplay(id,9);   
  }    
  
    const renderMarkers = (map, maps) =>
    {
      defaultCenter.map((post) => 
      {                     
        //setIsMoving(200);
       let marker = new maps.Marker(
        {          
        position: { lat: post.latitude, lng: post.longitude},
        map:map,
        icon:post.status=="Online"?avtlogo2:avtlogo,
        label : { color: 'black',left: 10,bottom: '-35px',position: 'relative',fontWeight: 'bold', fontSize: '30px'},
                 
     });
         
     const tooltipContent =
     '<div id="content">' +
     `<h5>${post.vehicleNumber}</h5>`  +
     "<button id='historyButton' ><span id='hlogo'> <i class='fas fa-history'></i></span> View History</button>"+
     `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i style="color:green; font-size:19px" class="fas fa-tachometer-alt"></i> <b>Speed:</b> <span class="speed">${post.speed}&nbsp;Km/hr</span>`+
     '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'+"<button id='ShareButton' ><span id='hlogo'> <i class='fa fa-share-alt'></i></span></button>"+
     `<input type='hidden' id='hdndeviceId' value=${post.imeiNumber} />`+
     `<input type='hidden' id='hdnvehicleno' value=${post.vehicleNumber.replace(/ /g, '')} />`+
     `<div class="d-flex mb-3 align-items-center"><div><p class="flex-1 text-large mb-0"><strong><i class="fas fa-key ${post.acc==0?"text-danger":"text-success"}"></i> Ignition: </strong><span class=${post.acc==0?"text-danger":"text-success"}>${post.acc==0?"OFF":"ON"} </span></p> </div> <div style="display:${post.acc==0?"none":"block"}">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a id='viewliveButton' class='btn mb-0 fw-bold'><i class="fas fa-circle text-success"></i> View Live</a></div></div>` +
     `<div class="d-flex mb-3 align-items-center"><div><p><strong><i style="color:orange;" class="fas fa-user-astronaut"></i> Driver:&nbsp; </strong> ${post.driverName}</p> </div><div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<button class='btn mb-0 fw-bold' id='routehistoryButton' ><span id='hlogo'> <i class="fa-solid fa-play"></i></span> Route Playback</button></div></div>` +
     `<p><strong><i class="fa-sharp fa-solid fa-phone"></i> Driver Phone: </strong><a class='text-black'  href='tel:+91${post.driverNo}'>${post.driverNo} </a></p>`  +
     `<p><strong><i style="color:#23baf4;" class="fas fa-clock"></i> Last Updated:</strong> ${post.logDateTime}</p>` +
     `<p><strong><i style="color:magenta;" class="fa-solid fa-location-dot"></i> Current Location:</strong> ${post.address}</p>` +
     "</div>";
      
     
    const infoWindow = new window.google.maps.InfoWindow();
     infoWindow.setContent(tooltipContent);

    marker.addListener('click', () => 
      {        
            infoWindow.open(map, marker);      
      });
  //
  if(typeID==9)
  {
      infoWindow.open(map, marker);  
  }
  maps.event.addListener(infoWindow, "domready", function () 
  {
    document.getElementById("ShareButton").onclick=copyToURL
    document.getElementById("historyButton").onclick=showhistoryHandler
    document.getElementById("routehistoryButton").onclick=showroutehistoryHandler
    document.getElementById("viewliveButton").onclick=showliveHandler
    IEMI = document.getElementById("hdndeviceId").value;
    Svehicleno=document.getElementById("hdnvehicleno").value;
    

  });
 
  function showhistoryHandler(event)
  {
     setShowDetails(true);
    //setIsLoading(true); 
    setVehicleNo(Svehicleno);
    setImeiNo(IEMI);    
    setHimei(IEMI);
    setHfromdate(today);
    setHtodate(today);  

    //console.log("defaultHistoryProps.center");
    //console.log(defaultHistoryProps.center);
      //const daurls=API_URL+`HistoryonMap?Imei=${IEMI}&FromDate=${today}&Todate=${today}`;
      //const daurls=API_URL+`HistoryonMap?Imei=${IEMI}&FromDate=2024-11-01&Todate=2024-11-01`;
      //alert(daurls);
    //const response =  axios.get(daurls).then(response => 
    // {  
            
       //setdataPoints(response.data.data);
       //setLatitude(response.data.data[0].lat);
       //setLlongitude(response.data.data[0].lng);
       //var latt1=response.data.data[0].lat;
       //var lngg1=response.data.data[0].lng;
       //setSLatlong("lat:"+ "22.1546", "lng:"+ "25.2566");
       //console.log("SLatlong");
       //console.log(sLatlong);
       //defaultHistoryProps.center={latt1,lngg1};
       //alert(latt1);
       //alert(lngg1);
       //alert(defaultHistoryProps.center);
       //console.log("---------------Data--------------------"); 
      // console.log(response.data.data);      
        
      //}).catch(function(error) 
      //{
        //   console.log(error.message);
      // }); 
  }
  function showroutehistoryHandler(event)
  {
       
    var fdays = new Date();
    var fdds = fdays.getDate();
    var fmms = fdays.getMonth() + 1; //January is 0 so need to add 1 to make it 1!
     var fyyyys = fdays.getFullYear();
    
      if (fdds < 10)
      {
            fdds ='0' + fdds
      }
      if (fmms < 10)
      {
            fmms = '0' + fmms
      }
       fdays = fyyyys + '-' + fmms + '-' + fdds;

       setFilterDate(fdays);      
       setShowPlayBackDetails(true);    
       setIsLoading(true);   
       setHistoryData([]);   

    const dvaurls=API_URL+`GetGPSRouteHistorylist/?FromDate=${today}&ToDate=${today}&IEMI=${IEMI}`;
    
    setImeiNo(IEMI);
  
    const response =  axios.post(dvaurls).then(response =>
      {
        setIsLoading(false);
       
          if(response.data.validStatus)      
          {      
            setHistoryData(response.data.data);
          } 
          else
          {
            alert("No data found.");
            
          }  
      }).catch(function(error) 
      {
        toast.info("No History found !",{position: toast.POSITION.TOP_CENTER});
        setIsLoading(false);
         console.log(error.message); 
      });
  }
  function showliveHandler(event)
  {    
     GoToViewLivePage();
  }
      });      
    }
    const renderHistoryMarkers = (map, maps) =>
     {
       defaultCenter.map(() => 
       {                     
          let marker = new maps.Marker(
          {          
          position: { lat: 22.45617, lng: 77.15228},
          map:map,
          icon:avtlogo,
          label : { color: 'black',left: 10,bottom: '-35px',position: 'relative',fontWeight: 'bold', fontSize: '30px'},
                   
       });
       //setVehicleNo(post.vehicleNumber);
       
       const tooltipContent ='<div id="content">' +
       `<h5>${vehicleNo}</h5>`  +
       "</div>";  
        
       
      const infoWindow = new window.google.maps.InfoWindow();
       infoWindow.setContent(tooltipContent);
  
      marker.addListener('click', () => 
        {        
              infoWindow.open(map, marker);      
        });
  
    maps.event.addListener(infoWindow, "domready", function () 
    {      
  
    });   
    
  
   
        });      
      }
{/**/}
function VMap(props)
{
      return  <div className="container-fluid p-3">
      <div class="card m-0 shadow border-0">
      <div className="content" id="Gmap"> 
      <GoogleMapReact  
        bootstrapURLKeys={{ key:process.env.REACT_APP_MAPKEY }}       
        onClick={onMapClick}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}             
        options={function (maps) { return { mapTypeId: "terrain" } }}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map, maps }) => renderMarkers(map, maps)}>         
      </GoogleMapReact>      
      </div></div></div>
     
}


  const MapBinding=(DeviceId,TypeID)=>
  {
       
    (async () => 
    {    
    
      const daurls=API_URL+`AllDeviceLocation/${AccountID}/${DeviceId}/${TypeID}`;  
     
      setPosts([]); 
      const response = await axios.get(daurls).then(response => 
        {                            
          setIsLoading(false);
          const data = response.data.data;
          setLatitude(data[0].latitude); 
          setLlongitude(data[0].longitude);               
          setPosts(data);     
          console.log("items");
          console.log(items);             
        
    }).catch(function(error) 
    {     
          setIsLoading(false);
          console.log(error.message);    
    });    
      console.log(response);     
    })(); 
  }
 
  const Mapdisplay=(Device_Id,Type_ID)=>
  {

         setAccount_ID(AccountID);
          setDevice_ID(Device_Id);
          setType_ID(Type_ID);
          setTypeID(Type_ID);
          MapBinding(Device_Id,Type_ID);  

          //GT-196
         // myComponent =   <VMap brand={ typeID } />
          myComponent=<DashboardMap objmapdata = { mapData }/>                

  }  
 const ViewDashboardCount=()=>
 {
        const daurls=API_URL+`Dashboard/${AccountID}`; 
        //alert(daurls);
        const response =  axios.get(daurls).then(response => 
          {       
                setMoving(response.data.data[0].moving);
                setParked(response.data.data[0].parked);               
                setIdle(response.data.data[0].idle);
                setNotUpdated(response.data.data[0].notUpdated);
    
          }).catch(function(error) 
           {
                console.log(error.message);

          });    

 }
 //Faiz 27-11-24 for Map on History
 const defaultHistoryProps = 
    {
      
      center: {
        lat:28.387816 ,
        lng:77.35126 
      },
      zoom: 14
    }; 
 //timer 20 second will update Summary count
 useEffect(() => {
  let interval = setInterval(() => 
  {    
    ViewDashboardCount();       
    Mapdisplay(0,0);//new addedd
  }, 20000);

  return () => clearInterval(interval);
}, []);

const Blanck= () => 
{}

//Acknoledge alert update
const AlertAck=(MSGID)=>
{
    const daurls=API_URL+`ACKMessage/?AccountID=${AccountID}&MSGID=${MSGID}&User=${login_name}`;  
    const response =  axios.get(daurls).then(response => 
    {   
      
     showVehicleAlert(1);         
     toast.success("Acknowledge successfully.");      

    }).catch(function(error) 
     {
          console.log(error.message);
    });   
 
}       
      
  //Alert Process
    const showVehicleAlert = (b) => 
    {
      if(alertTotal>0)
      {       
          setShowAlerts(true);
      }
      if(b==0)
      {
         setMsg_Type(0);//All
      }
      else if( b==2)
      {
        setMsg_Type(2);//Recent
      }
      else if(b==1)
      {        
        setMsg_Type(1);//Ack
      }
      
      const Type_ID=b;     
      const url=API_URL+`MessageList/?AccountID=${AccountID}&TypeID=${Type_ID}`;   
      
      setVAlert([]);
      setAlertTotal([0]);
      axios.get(url).then(response => 
        {  
            console.log("Alert data");
            console.log(response.data.data);
            const data = response.data.data;
            setVAlert(data);
            setAlertTotal(Object.keys(data).length);         
             
        }).catch(function(error) 
        {
              console.log(error.message);        
        });      
    }
        
    const showCustomerVehicleDetails = (b,c) => 
    { 
      const Type_ID=b;
      const Interval=c;
      
      const url=API_URL+`VehicleListForDash/?AccountID=${AccountID}&Type=${Type_ID}&Interval=${Interval}`;  
     
     console.log(url);
      setVDatas([]);
      setDeviceTotal([0]);
        axios.get(url).then(response => 
          {  
              console.log("Truck data");
              console.log(response.data.data);
              const data = response.data.data;
            
              setVDatas(data);
              setPosts(data);
              setDeviceTotal(Object.keys(data).length);

         }).catch(function(error) 
          {
                console.log(error.message);
          
          });    
    }
    const onMapClick = () => 
    {
      
      
    };

const dChangeHandler= (e) => 
  {
      setFilterDate(e.target.value); 
      setHistoryData([]);   
      const dvaurls=API_URL+`GetGPSRouteHistorylist/?FromDate=${e.target.value}&ToDate=${e.target.value}&IEMI=${imeiNo}`; 
      //alert(dvaurls);
    const response =  axios.post(dvaurls).then(response =>
      {
            setIsLoading(false);            
            setHistoryData(response.data.data);   
        
       
      }).catch(function(error) 
      {
        toast.info("No History found !",{position: toast.POSITION.TOP_CENTER});
        setIsLoading(false);
         console.log(error.message); 
        });
      
     }
    const dfrChangeHandler= (e) => 
    {
          setFrFilterDate(e.target.value); 
          setHistoryData([]);                  
    }
    const dtoChangeHandler= (e) => 
    {
          setToFilterDate(e.target.value); 
         setHistoryData([]);           
    }
//date ends
    const defaultProps = 
    {
      
      center: {
        lat: lat,
        lng: long
      },
      zoom: 14
    };


    //For Points on map history    
    //End map history

    var left = 20 + 'px';
    var top = 500 + 'px';
    var padding = 200 + 'px';
    if (isLoading) 
    {
          return <center>< LoadingSpinner/></center>;       
    }
    return(
    <>
    {
    <>  
        <div className="top-bar clearfix">
        <div className="row justify-content-between">
         <div class="col-12 col-lg-5 d-flex align-item-center">
         <h2 className="m-0"> Dashboard </h2>            
         <ReactSearchAutocomplete placeholder="Vehicle Number" items={items} onSearch={handleOnSearch} onHover={handleOnHover} onSelect={handleOnSelect} onFocus={handleOnFocus}   autoFocus formatResult={formatResult} /> 
         </div>            
         <div class="col-12 col-lg-7 d-flex justify-content-end flex-wrap">
         <div onClick={() => Mapdisplay(0,0)}  class="bg-3075b1 text-white dbBlock">
         <p class="m-0"><b>{moving+idle+parked+notUpdated}</b></p>
         <p class="m-0">All Vehicles</p>
         </div>          
         <div onClick={() => Mapdisplay(0,1)} class="bg-d3f2cb text-005500 dbBlock">
         <h4 class="m-0"><b>{moving}</b></h4>
         <p class="m-0">Moving</p>
         </div>
            <div onClick={() => Mapdisplay(0,2)} class="bg-fff6e3 text-653500 dbBlock">
              <h4 class="m-0"><b>{idle}</b></h4>
              <p class="m-0">Idle</p>
            </div>
            <div onClick={() => Mapdisplay(0,3)} class="bg-f5ecee text-620000 dbBlock">
              <h4 class="m-0"><b>{parked}</b></h4>
              <p class="m-0">Parked</p>
            </div>
            <div onClick={() => Mapdisplay(0,4)} class="bg-f3f3f3 text-333333 dbBlock">
              <h4 class="m-0"><b>{notUpdated}</b></h4>
              <p class="m-0">No Network</p>
            </div>            
          </div>         
         </div>
      </div>      
      {myComponent}       
      
       </>
    }
    {/* comment GT-196
    <ModalHistory style={{ zIndex:"9999999"}} isOpen={showDetails} >
     <div class="modal-header">
                <h5 className='modal-title'>History Details</h5>
                <button type="button" class="btn-close" onClick={closeModal}></button>
     </div>
                <div class="modal-body" >                  
                <span style={{float: "left"}}>
                <button type="button" class="btn btn-primary2 mt-20" tabindex="1" id="btnTodayData" onClick={ShowTodayData} >Today</button>
                <button type="button" class="btn btn-primary2 mt-20" tabindex="2" id="btnWeeklyData" onClick={ShowWeeklyData} >Weekly</button>
                <button type="button" class="btn btn-primary2 mt-20" tabindex="3" id="btnMonthlyData" onClick={ShowMonthlyData} >Monthly</button>
                </span>
                <div class="row" >
                <div class="col-sm-1 col-md-1 form-group">From:</div>
                <div class="col-sm-4 col-md-4 form-group">
                <input type="date" className="form-control"  value={frFilterDate}  placeholder="dd-mm-yyyy" onChange={dfrChangeHandler}  min={minDatefr} max={today} />
                </div>
                <div class="col-sm-1 col-md-1 form-group" >To:</div>
                <div class="col-sm-4 col-md-4 form-group">
                <input type="date" className="form-control"  value={toFilterDate}  placeholder="dd-mm-yyyy" onChange={dtoChangeHandler}  min={minDatefr} max={today} />
                </div>
                <div class="col-sm-1 col-md-1 form-group">
                <button type="button" class="btn btn-primary2 mt-20" tabindex="4" id="btnSearch" onClick={ShowSearchData} >Search</button>
                </div>
                </div>
                <div><b> Vehicle No : {vehicleNo}</b></div>
                <br /> 
                <div hidden={isShowMap}>                
                <HistoryonMap Historyobj={historyonmapinfo} /> 
                 </div>
               
                
                
                
                </div>
    </ModalHistory>
    
    <Modal style={{ zIndex:"9999999"}} isOpen={showPlayBackDetails} >
     <div class="modal-header">
                <h5 className='modal-title'>Route Playback</h5>
                <button type="button" class="btn-close" onClick={closeModal}></button>
                </div>
                <div class="modal-body" >
                <div class="row">
                    <div class="col-sm-2 col-md-2 form-group">
                    <b> Search By Date: </b>                         
		            </div>
                <div class="col-sm-4 col-md-4 form-group">
                <input type="date" className="form-control"  value={filterDate}  placeholder="dd-mm-yyyy" onChange={dChangeHandler} />
                
                </div>
                <div class="col-sm-6 col-md-6 form-group"></div>
                </div>
               
                {historyData.map(item => 
                (                       
                <div key={item.tripno}  class="card px-12 mb-10">                    
                <div class="row"><div class="card-header">
                <b style={{color:"red"}}> Stopped: </b>{item.haltFromPreviousTrip}
                </div><div class="card-body py-0"><div class="row"><div class="col-md-4 col-lg-2 p-0"><img  onClick={() => GoToroutePlaybackPage(item.vehicleNumber,item.tripno)}  class="img-fluid rounded-start" src="../img/RPlayBack.png" title="View Route Playback" style={{ height: "100% !important", cursor: "pointer"}}/></div><div class="col-md-8 col-lg-10 border-start" >
                <div class="card-text" ><b> Source : </b>
                    {item.tripStartDateTime}
                    <b style={{ padding:"0px 0px 0px 120px"}}> Destination : </b>
                    {item.tripEndDateTime}<br/>
                    <i style={{"color":"green"}} class="fas fa-map-marker-alt"></i>   &nbsp;&nbsp;
                    {item.startAddress} <br/>
                    <i  class="fas fa-long-arrow-alt-down"></i>
                    <br/>
                    <i style={{"color":"red"}}  class="fas fa-map-marker-alt"></i>   &nbsp;&nbsp;
                    {item.endAddress}
                   </div>                    
                </div></div></div><div class="card-footer">
                <b> Distance : </b>
                    {item.distance} km
                    <b style={{ padding:"0px 0px 0px 200px"}}> Avg. Speed : </b>
                    {item.averageSpeed} km/hour
                  </div></div></div>
                    
                   
                 )
                )
                
                }
                
                
                </div>
    </Modal>
    */}
    {/* Alert Popup*/}
    <Modal style={{ zIndex:"9999999"}} isOpen={showAlerts} >
     <div class="modal-header">
                <h5 className='modal-title'>Alert Details</h5>
                <button type="button" class="btn-close" onClick={closeModal}></button>
                </div>
                <div class="modal-body" style={{ "height": "672px", "overflow-y": "auto","overflow-x": "hidden"}} >
                
                {vAlert.map(item=>
                    (
                      <div class="shadow px-2 py-3 rounded-2 mb-3">
                        <div class="row">
                          <div class="col-1">    
                            
                            </div>
                          <div class="col-8">     

                          <i class={item.status==="Online"?"fa-duotone fa-square text-success":"fa-duotone fa-square  text-danger"}></i>  
                          {item.vehicleNumber} &nbsp; &nbsp; &nbsp; &nbsp;<a href="#" title={item.smsContent}> {item.alertType}</a>                                                   
                              <div class="d-block mb-1">  </div>
                              <div class="d-block mb-1"> 
                              <div><b>Priority:&nbsp; </b>
                              <strong class={item.priorities==="Critical"?"text-danger":(item.priorities==="Low"?"text-success":"text-warning")}>{item.priorities}</strong> </div>                              
                              </div>
                              <div class="d-block mb-1"><b>Received Time</b> - {item.receiveTime} </div> 
                              <div class="d-block mb-1"><b>Message</b>-{item.smsContent}</div> 
                                          
                             <div></div>
                              </div>                            
                             <div class="col-3">
                              <button  onClick={() => AlertAck(`${item.msgid}`)} class="btn btn-info">Acknowledge</button>
                              </div>
                              
                            </div>
                          </div>
                          ))}
                
                </div>
    </Modal>
    {/*End of popup*/}
    {/*Open Route Model -----------------comment GT-196
    <Modal style={{ zIndex:"9999999"}} isOpen={showRoute} >
     <div class="modal-header">
     <h5 className='modal-title'>Route History Details</h5>
     <button type="button" class="btn-close" onClick={closeModal}></button>
     </div>   
     
     <div class="modal-body" style={{ "height": "672px", "overflow-y": "auto","overflow-x": "hidden"}} >
      <RouteonMap Routeobj={route_Info}/>
     </div>
    </Modal>*/}
    {/*End route*/}
     {/*Open Route Playback Model --------comment GT-196
     <Modal style={{ zIndex:"9999999"}} isOpen={showRoutePlayback} >
     <div class="modal-header">
     <h5 className='modal-title'>Route Details</h5>
     <button type="button" class="btn-close" onClick={closeModal}></button>
     </div>   
     <div class="modal-body" style={{ "height": "672px", "overflow-y": "auto","overflow-x": "hidden"}} >
     <Playback Routeobj={routeinfo}/>
     </div>
    </Modal>*/}
    {/*End Route Playback*/}
    <ToastContainer position="bottom-right" autoClose={4000} theme="light"/> 
    </>);
    <script>
    $('document').ready(function(){
                 $('.menu').click(function()
                 {
                 $('body').toggleClass('close')
                 })
             })
    </script>
}
export default VehiclesMonitor;